<template>
  <div class="MyOrder">
    <div class="add">
      <el-button type="primary" plain @click="handleToReturnGoods()">
        新增退货申请
      </el-button>
    </div>
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>商品</span>
        <span>单价</span>
        <span>数量</span>
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderHeader">
            <span class="orderTime">{{ item.xbqdlsk88vhorc0b }}</span>
            <span class="orderId">
              {{ '退货单编号：' + item['3pp6dg9j4ex79ook'] }}
            </span>
          </div>
          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <img
              :src="
                order.bal0wugwwskobosz && order.bal0wugwwskobosz.length > 0
                  ? order.bal0wugwwskobosz[0].url
                  : ''
              "
              alt="商品图片"
            />
            <div class="goodsName">
              <p
                @click="navTo('/mall/goods/' + order.tlztdbj3bxchs5vi[0].id)"
                v-if="
                  order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi.length > 0
                "
              >
                {{ order.tlztdbj3bxchs5vi[0].value }}
              </p>
            </div>
            <span class="unitPrice">{{
              '￥' + (order.u9h1eshiivxuuuc0 || 0)
            }}</span>
            <span class="num">{{ order['mbvjcurb6r0ckynw'] || 0 }}</span>
            <span class="status" v-if="idx === 0">
              <!-- {{ item.qpfsvknudb8gbzee }} -->
              <img
                src="@/assets/img/shz.svg"
                alt=""
                v-if="
                  item.qpfsvknudb8gbzee ===
                  'ead617a0-f13a-49c6-b7d0-c18355f330c0'
                "
              />
              <img
                src="@/assets/img/success.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  'f5d63c14-f8ee-4279-81f8-4d63ae88df9c'
                "
              />
              <img
                src="@/assets/img/fail.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
                "
              />
              <img
                src="@/assets/img/ywc.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  'fa14a408-0e3c-45dd-95d0-b8f5286fbb91'
                "
              />
            </span>
          </div>
          <div class="orderfooter">
            <!-- 物流单号 + 审核成功待发货 -->
            <el-button
              type="primary"
              v-if="
                item['3u7sabpxxpxioiqz'] &&
                item.qpfsvknudb8gbzee === 'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc'
              "
              @click="confirmMailing(item)"
            >
              确认邮寄
            </el-button>
            <el-button
              type="primary"
              v-if="
                item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
              "
              @click="resubmit(item)"
            >
              重新提交
            </el-button>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/order.svg" alt="" />
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import {
  online,
  children,
  execButton
} from "@/api/platform";
import { otherSystemGetLoginToMeUrl } from "@/util/util";
export default {
  name: "MyOrder",
  components: {
    Popup,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        {
          name: "全部",
          form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
        },
        { name: "审核中", form_head_uuid: "da5b79bf0c5e42bf9c21086558a3b35d" },
        {
          name: "审核成功",
          form_head_uuid: "a208859626184a78a365637cab7eb8bc",
        },
        {
          name: "审核失败",
          form_head_uuid: "a30bcbae0e9a44cbb63990644da739cc",
        },
        {
          name: "已邮寄",
          form_head_uuid: "28712136e07547789bd205c4ce9e0962",
        },
        {
          name: "验收中",
          form_head_uuid: "6b27a6c33c294e5198e53197cf37fd96",
        },
        {
          name: "已验收",
          form_head_uuid: "8802255844c64e3e8492c64153abbae1",
        },
        {
          name: "退货完成",
          form_head_uuid: "d1520d82d4a146bb9f0774e108861c23",
        },
      ],
      form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
    };
  },

  methods: {
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      this.orderList = await Promise.all(
        result.map(async (el) => ({
          ...el,
          children: await this.children(el.id),
        }))
      );
      this.total = meta.total;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "9aa0f944e2c64efbbb752b8314330d23",
        form_head_uuid,
        record_id,
      });
      return result;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    // 跳转到退货申请
    handleToReturnGoods () {
      otherSystemGetLoginToMeUrl('645c1772e59411eeaebb0242ac150003', 'fWqATRfis9uqvpDQ')
    },
    // 确认邮寄
    async confirmMailing (item) {
      this.page = 1;
      await execButton({
        button_uuid: "b58f4973-d95c-4511-ba77-e44f67189c24",
        form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
        id: item.id,
        type: 2,
      })
      // this.getOrderList();
      this.$notify({
        title: "提示",
        message: "确认邮寄成功",
        type: "success",
      });
      setTimeout(() => {
        this.getOrderList();
      }, 2000);
    },
    // 重新提交
    async resubmit (item) {
      this.page = 1;
      await execButton({
        button_uuid: "8f0b304a-058c-4603-ba85-36aee3e452ed",
        form_head_uuid: "30cfd060adfe11ee81ef0242321230b4",
        id: item.id,
        type: 2,
      })
      this.$notify({
        title: "提示",
        message: "重新提交成功",
        type: "success",
      });
      setTimeout(() => {
        this.getOrderList();
      }, 2000);

    },
  },

  mounted () {
    this.getOrderList();
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.MyOrder {
  position: relative;
  .add {
    // position: absolute;
    // right: 5px;
    // top: 3.5px;
  }
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .orderBox {
    width: 100%;
    margin-top: 20px;
    .orderTableHeader {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid @borderColor;
      color: @fontDefaultColor;
      font-size: 14px;
      line-height: 40px;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
        width: 150px;
        line-height: 40px;
        text-align: center;
        &:first-child {
          width: 500px;
        }
      }
    }
    .orderList {
      width: 100%;
      li {
        border: 1px solid @borderColor;
        font-size: 13px;
        margin-top: 10px;
        .orderHeader {
          background-color: #f1f1f1;
          height: 40px;
          line-height: 40px;
          padding: 0 5px;
          .orderTime {
            font-weight: 600;
          }
          .orderId,
          .state {
            margin-left: 10px;
          }
          .deleteBtn {
            float: right;
            cursor: pointer;
            i {
            }
          }
        }
        .orderDetail {
          width: 100%;
          padding: 10px;
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: flex-start;
          img {
            width: 84px;
            height: 84px;
            display: inline-block;
          }
          .goodsName {
            display: inline-block;
            margin-left: 5px;
            width: 400px;
            vertical-align: top;
            p {
              cursor: pointer;
              line-height: 20px;
              &:hover {
                text-decoration: underline;
              }
            }
            span {
              color: @fontDefaultColor;
              display: block;
              margin-top: 10px;
            }
          }
          .unitPrice,
          .num,
          .amount,
          .hasComment {
            display: inline-block;
            vertical-align: top;
            width: 150px;
            height: 85px;
            line-height: 85px;
            text-align: center;
          }
          .status {
            position: absolute;
            right: 10px;
            img {
              width: 70px;
              opacity: 0.9;
            }
          }
          button {
            position: absolute;
            right: 90px;
            top: 50%;
            transform: translate(0, -50%);
            width: 70px;
            height: 30px;
            border-radius: 3px;
            background-color: @thirdColor;
            color: white;
            border: none;
          }
        }
        .orderfooter {
          display: flex;
          justify-content: flex-end;
          padding: 10px;
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
.emptyTips {
  text-align: center;
  margin: 200px auto;
}
/deep/.el-form {
  .el-table {
    table thead tr {
      height: 36px;
      line-height: 36px;
      .cell {
        font-weight: normal;
        color: #333;
      }
      .el-table__cell {
        border-bottom: 0;
      }
    }
    .el-table__cell {
      padding: 0;
    }
    .input-inner {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: 8px;
    }
  }

  .el-select {
    width: 100%;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-table__header {
    border: 0;
  }
  .el-table__row {
    .cell {
      padding: 0;
    }
    .el-input__inner {
      border: 0;
    }
  }
  .el-form-item-col {
    display: flex;
    justify-content: flex-start;
    .el-form-item__label {
      width: 100px;
      text-align: left;
    }
    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/ReturnGoods.vue